import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import "/src/styles/SpeakersPage.css"

import Layout from "../components/layout"
import Seo from "../components/seo"
import EventAppearances from "../components/event-appearances"
import { GatsbyImage } from "gatsby-plugin-image"

const PageTemplate = ({ data }) => {
  const speakers = data.allMarkdownRemark.nodes
  return (
    <Layout>
      <Seo title="CSICon Speakers & Guests" />
      <div className="RowContainer__OuterContainer">
        
        <div className="page-header">
          <h1>
            <strong>CSICon Speakers List</strong>
          </h1>
          <hr />
        </div>
        
        <div className="AttendeeList__AttendeeListWrapper AttendeeList__GridWrapper">
          {speakers.map(speaker => (
            <div key={speaker.frontmatter.slug} id={speaker.frontmatter.slug} className="speaker-card">
              <div className="speaker-headshots-wrapper">
                <GatsbyImage
                image={
                  speaker.frontmatter.featuredImage.childImageSharp
                    .gatsbyImageData
                }
                alt={speaker.frontmatter.title}
                className="speaker-headshots"
                loading="lazy"
              />
              </div>
              <div className="speaker-bio-text">
                <p>
                  <strong>{speaker.frontmatter.title}</strong>
                </p>
                {parse(speaker.html)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default PageTemplate

export const speakerQuery = graphql`
  query AllSpeakers {
    allMarkdownRemark(
      filter: { frontmatter: { type: { eq: "speaker" } } }
      sort: { fields: frontmatter___slug, order: ASC }
    ) {
      nodes {
        html
        frontmatter {
          title
          featuredImage {
            childImageSharp {
              gatsbyImageData(
                formats: WEBP
                height: 400
                width: 400
                quality: 70
                placeholder: BLURRED
                transformOptions: { cropFocus: CENTER, fit: COVER }
              )
            }
          }
          slug
        }
      }
    }
  }
`